export default "__VITE_ASSET__xI_EMtkJ__"